import {GlobalNavBar} from '@github-ui/global-navigation/bar'
import {registerReactPartial} from '@github-ui/react-core/register-partial'

registerReactPartial('global-nav-bar', {
  Component: GlobalNavBar,
})
